// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__24efO","imageUploader":"EGiftCard_imageUploader__10kI5"};